import { render, staticRenderFns } from "./PricingTableDesktopDetail.vue?vue&type=template&id=4a1249f7&scoped=true&"
import script from "./PricingTableDesktopDetail.vue?vue&type=script&lang=js&"
export * from "./PricingTableDesktopDetail.vue?vue&type=script&lang=js&"
import style0 from "./PricingTableDesktopDetail.vue?vue&type=style&index=0&id=4a1249f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1249f7",
  null
  
)

export default component.exports